import React from "react";
import { Link } from "react-router-dom";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const img = (p) => `${BACKEND}${p}`;

const CustomCta = () => {
  return (
    <section className="relative overflow-hidden bg-[var(--ivory)] py-28 lg:py-40 vc-grain" data-testid="custom-cta">
      <div className="relative max-w-[1440px] mx-auto px-6 lg:px-20 z-[2]">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-stretch">
          {/* Image */}
          <div className="lg:col-span-7 relative vc-copper-halo order-2 lg:order-1">
            <div className="relative aspect-[4/3] lg:aspect-[5/4] overflow-hidden vc-img-zoom">
              <img
                src={`${BACKEND}/api/static/products/studio-03.webp`}
                srcSet={`${img("/api/static/products/studio-03-480.webp")} 480w, ${img("/api/static/products/studio-03.webp")} 1050w`}
                sizes="(min-width: 1024px) 55vw, 100vw"
                alt="Custom commission — bespoke lighting from the Venus studio"
                loading="lazy"
                decoding="async"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="hidden lg:block absolute -top-6 left-6 font-serif-display italic text-[var(--copper)] text-5xl leading-none">
              N°03
            </span>
            <div className="absolute left-6 bottom-6 bg-[var(--espresso)] text-[var(--cream)] px-5 py-2 text-[10px] tracking-[0.35em] uppercase">
              Bespoke
            </div>
          </div>

          {/* Copy */}
          <div className="lg:col-span-5 flex flex-col justify-center order-1 lg:order-2 lg:pl-6">
            <p className="vc-eyebrow text-[var(--copper)] mb-10 vc-fade-up" data-testid="custom-eyebrow">
              Custom Commissions
            </p>
            <h3 className="font-serif-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.08] text-[var(--espresso)] max-w-md vc-fade-up vc-stagger-1">
              Have something in mind we <em className="italic text-[var(--copper)]">haven&apos;t</em> made yet?
            </h3>
            <div className="mt-10 vc-divider max-w-[200px] vc-fade-up vc-stagger-2" />
            <p className="mt-8 text-[var(--espresso)]/65 leading-[1.9] max-w-md tracking-wide vc-fade-up vc-stagger-2">
              From heirloom sculptures to bespoke lighting, our studio takes on a limited number of commissions each month. Share a reference or an idea — we&apos;ll respond within 48 hours.
            </p>
            <div className="mt-12 flex flex-wrap items-center gap-8 vc-fade-up vc-stagger-3">
              <Link
                to="/contact"
                data-testid="custom-cta-start"
                className="vc-btn-ghost inline-flex items-center h-12 px-10 text-[11px] tracking-[0.28em] uppercase"
              >
                Start a commission
              </Link>
              <Link
                to="/about"
                className="text-[11px] tracking-[0.28em] uppercase text-[var(--espresso)]/70 vc-link-underline"
              >
                See the process
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CustomCta;
